"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var reactstrap_1 = require("reactstrap");
var ValidatedFormFeedback_1 = require("./ValidatedFormFeedback");
/**
 * Wrapper around Input that will set invalid="true" if we have any errors passed in for our name.
 * @param props
 */
exports.ValidatedInput = function (props) {
    // Use the ...rest technique to remove our own props from those we need to pass on to Input.
    var component = props.component, validationErrors = props.validationErrors, hideFormFeedback = props.hideFormFeedback, rest = tslib_1.__rest(props, ["component", "validationErrors", "hideFormFeedback"]);
    // Find the errors based on the types we support.
    var errors = [];
    if (!validationErrors) {
        // Errors can stay as an empty array.
    }
    else if (typeof validationErrors === 'string') {
        errors = [validationErrors];
    }
    else if (Array.isArray(validationErrors)) {
        errors = validationErrors;
    }
    else {
        // We have ValidationErrors from Validator.errors()
        errors = validationErrors[(props.name ? props.name : '')] || [];
    }
    var hasErrors = errors.length ? true : false;
    var Component = component || reactstrap_1.Input;
    return (React.createElement(React.Fragment, null,
        React.createElement(Component, tslib_1.__assign({}, rest, { invalid: hasErrors })),
        hideFormFeedback ? (React.createElement(React.Fragment, null))
            : (React.createElement(ValidatedFormFeedback_1.ValidatedFormFeedback, { name: props.name, validationErrors: props.validationErrors }))));
};
//# sourceMappingURL=ValidatedInput.js.map